
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/fashionunited-newsletter",
      function () {
        return require("private-next-pages/fashionunited-newsletter.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/fashionunited-newsletter"])
      });
    }
  